module.exports = __webpack_public_path__ + "fonts/6a993fb02073036150f77419ea8e2090.svg";